<template>
  <div class="subs">


    <div class="table-scroll">
      <table class="table is-striped is-hoverable is-fullwidth">
        <thead>
        <th>שם</th>
        <th>שם משתמש</th>
        <th>סוג חשבון</th>
        <th>תאריך החיוב הבא</th>
        <th>ביטול טוקן</th>
        <th>סטטוס חשבון</th>
        <th>חיוב ידני</th>
      </thead>
        <tbody>
          <sub-item v-for="sub in subs" :key="sub.id" :sub="sub"></sub-item>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SubItem from "./SubItem";
import SubFilter from "./SubFilter";

export default {
  props: {
    subs: Array
  },
  components: {
    SubItem,
    SubFilter
  }
};
</script>

